/**
 * Helper method to defer update until last update completes.
 * Expects a Promise.
 */
export const defer = () => {
  let size = 1;
  let nextFn: null | (() => Promise<void>) = null;
  function run(fn: () => Promise<void>) {
    if (size) {
      size--;
      return fn().then(release);
    }
    nextFn = fn;
    return;
  }
  function release() {
    size++;
    if (nextFn) {
      run(nextFn);
      nextFn = null;
    }
  }
  return {
    run,
    cancel: () => {
      nextFn = null;
    },
  };
};
